import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { reduceResolution, wbp } from 'Theme';

export const useSingleSaleTableItemTaxesSelectorStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            position: 'relative',
            borderRadius: '100px',
            border: '1px solid black',
            justifyContent: 'space-between',
            alignItems: 'center',
            cursor: 'pointer',

            [theme.breakpoints.down(wbp)]: {
                height: 36,
                paddingLeft: 19
            },
            [theme.breakpoints.up(wbp)]: {
                height: '46px',
                paddingLeft: '10px',
                minWidth: '100px'
            }
        },
        selectedTax: {
            width: '100%',
            fontSize: 14,
            textAlign: 'right',
            fontFamily: 'Poppins',

            [theme.breakpoints.up('md')]: {
                fontSize: 15
            }
        },
        icon: {
            [theme.breakpoints.down(wbp)]: {
                fontSize: `${reduceResolution(18)}px`,
                margin: `0px ${reduceResolution(10)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                margin: '0px 10px'
            }
        },
        list: {
            top: 44,
            left: 0,
            zIndex: 20,
            display: 'flex',
            overflowY: 'auto',
            position: 'absolute',
            flexDirection: 'column',
            border: '1px solid black',
            backgroundColor: 'white',
            padding: '8px 0px',
            borderRadius: 14,
            cursor: 'default',
            maxWidth: 160,

            [theme.breakpoints.down('sm')]: {
                right: 0,
                left: 'auto'
            },
            [theme.breakpoints.up('md')]: {
                top: '55px',
                maxWidth: 200,
                borderRadius: '14px',
                padding: '10px 0px'
            }
        },
        taxContainer: {
            'cursor': 'pointer',
            'paddingTop': 10,
            'paddingBottom': 10,
            'paddingLeft': 20,
            'paddingRight': 20,
            '&:hover': {
                background: '#F5F5F5'
            }
        },
        tax: {
            fontSize: 16,
            lineHeight: 1,
            fontWeight: 500,
            color: '#222222',
            overflow: 'hidden',
            display: 'block',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis'
        }
    })
);
